import type { ReactNode } from 'react';
import WithTooltip from '../Fundamentals/Tooltip/WithTooltip';

interface WorksheetSummaryCardProps {
    label: string;
    tooltip?: ReactNode;
    children: ReactNode;
}

const WorksheetSummaryCard = ({ label, tooltip, children }: WorksheetSummaryCardProps) => {
    const labelElement = <span className="body-sm text-secondary">{label}</span>;

    return (
        <div className="flex-1 d-flex flex-column gap-8 p-16 rounded-8 border bg-secondary">
            {tooltip === undefined ? (
                labelElement
            ) : (
                <WithTooltip content={tooltip} className="align-self-start" focusable>
                    {labelElement}
                </WithTooltip>
            )}
            {children}
        </div>
    );
};

export default WorksheetSummaryCard;
